import styled from 'styled-components'
import tw from 'twin.macro'

export const Section = styled.div`
  ${tw`my-10`}
`
